const LINEUP_ONE =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/e9aq6ryf_army%20of%20bands2.jpg";
const LINEUP_TWO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_wearspray-refresh/artifacts/e9aq6ryf_army%20of%20bands2.jpg";

export const LineupShowcase = () => (
  <div className="absolute inset-0" data-testid="lineup-showcase">
    <img loading="lazy"
      src={LINEUP_ONE}
      alt="A converging lineup of colorful WearSpray wearables with a glowing pink center face"
      className="lineup-img lineup-a"
    />
    <img loading="lazy"
      src={LINEUP_TWO}
      alt="The same WearSpray lineup with an electric plasma effect igniting inside the center face"
      className="lineup-img lineup-b"
    />
    <div className="lineup-plasma" aria-hidden="true">
      <div className="lineup-plasma-ring" />
      <div className="lineup-plasma-ring lineup-plasma-ring--rev" />
      <div className="lineup-plasma-core" />
    </div>
    <div className="lineup-plasma-side lineup-plasma-side--left" aria-hidden="true">
      <div className="lineup-plasma-ring" />
      <div className="lineup-plasma-core" />
    </div>
    <div className="lineup-plasma-side lineup-plasma-side--right" aria-hidden="true">
      <div className="lineup-plasma-ring" />
      <div className="lineup-plasma-core" />
    </div>
  </div>
);
